import { Auth } from 'aws-amplify';

export const fetchUserId = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    return user.attributes.sub;
  } catch (error) {
    console.error('Error fetching user ID:', error);
    return null;
  }
};